<template>
  <v-container fluid pa-0 ma-0 fill-height>
    <v-layout row wrap class="ma-0">

      <v-toolbar class="pa-0 ma-0 extension-padding"
                 color="white" flat dense fixed scroll-off-screen
                 ref="toolbarPlayer">
        <v-btn small flat icon @click="$router.go(-1)">
          <v-icon size="24px">$vuetify.icons.navArrowLeft</v-icon>
        </v-btn>
        <h3 class="display-2"
            style="margin-bottom: 2px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
            v-text="lecture.title">
        </h3>

        <!-- 비디오 플레이어 -->
<!--        <template v-slot:extension>-->
<!--          <v-img :src="thumbnailSrc" :aspect-ratio="16/9">-->
<!--            <VideoPlayer ref="wrapper" v-if="playerOptions.sources.length"-->
<!--                         class="vjs-custom-player"-->
<!--                         :options="playerOptions"-->
<!--                         :cross-origin="`use-credentials`"-->
<!--                         :playsinline="true"-->
<!--                         @ready="onPlayerReady"-->
<!--                         @loadeddata="onLoaded"-->
<!--                         @ended="onEnded"-->
<!--                         @error="onError" />-->
<!--            <iframe v-else-if="lecture.video_type === 'youtube'" id="player" type="text/html" width="100%" height="100%"-->
<!--                    :src="`https://www.youtube.com/embed/${lecture.guid}?enablejsapi=1&origin=${origin}&playsinline=1&modestbranding=1&rel=0`"-->
<!--                    frameborder="0"></iframe>-->
<!--          </v-img>-->
<!--        </template>-->
      </v-toolbar>

      <v-flex mt-5 pt-5 xs12>
        <p>해당 서비스는<br>유스 앱에서 이용해주세요!</p>
        <v-btn href="https://www.youth.lol/app/store" target="_blank" depressed color="white" large>유스 앱 다운로드</v-btn>
        <v-img :src="require('@/assets/img/mobile-search.png')"></v-img>
      </v-flex>


<!--      <v-flex xs12 :style="{ 'padding-top': paddingTop + 'px' }">-->
<!--        <v-tabs v-model="activeTab" mandatory grow slider-color="primary" color="#f8f8f8">-->
<!--          <v-tab :ripple="false" value="StoryNote" href="#StoryNote">스토리 노트</v-tab>-->
<!--          <v-tab :ripple="false" value="Curriculum" href="#Curriculum">커리큘럼</v-tab>-->

<!--          &lt;!&ndash; 스토리 노트 &ndash;&gt;-->
<!--          <v-tab-item value="StoryNote">-->
<!--            <v-container class="pa-0 pt-3">-->
<!--              <v-layout>-->
<!--                <v-flex class="product-style" v-html="lecture.story_note"></v-flex>-->
<!--              </v-layout>-->
<!--            </v-container>-->
<!--          </v-tab-item>-->

<!--          &lt;!&ndash; 커리큘럼 &ndash;&gt;-->
<!--          <v-tab-item value="Curriculum" style="background-color: white;">-->

<!--            <v-expansion-panel v-model="openPanel" expand flat class="curriculum" style="box-shadow: none;">-->
<!--              <v-expansion-panel-content expand-icon="$vuetify.icons.arrowDown" v-for="(chapter, index) of curriculum" :key="index">-->
<!--                <template v-slot:header>-->
<!--                  <v-layout column>-->
<!--                    <div v-if="chapter.number !== 0" style="display: flex;" class="justify-space-between">-->
<!--                      <span style="font-size: 14px; letter-spacing: -0.2px; color: #ec2f54; font-weight: 700;">-->
<!--                        Chapter. {{ chapter.number }}-->
<!--                      </span>-->
<!--                      <span style="font-size: 12px; color: #ec2f54; margin-right: -16px;">{{ progressPercentage[index] }}%</span>-->
<!--                    </div>-->
<!--                    <h1 class="display-4">{{ chapter.title }}</h1>-->
<!--                  </v-layout>-->
<!--                </template>-->

<!--                <v-list>-->
<!--                  <v-list-tile v-for="lecture in chapter.lectures" :key="lecture.idx"-->
<!--                               class="py-2"-->
<!--                               style="height: auto;">-->
<!--                    <v-list-tile-avatar :class="{ complete: lecture.complete }"-->
<!--                                        :color="lecture.complete ? 'primary' : '#cdcdcd'"-->
<!--                                        size="16px">-->
<!--                      <v-icon size="16px" color="white">$vuetify.icons.confirm</v-icon>-->
<!--&lt;!&ndash;                      &lt;!&ndash; TODO: indicator color &ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;                      <div class="indicator"></div>&ndash;&gt;-->
<!--                    </v-list-tile-avatar>-->
<!--                    <v-list-tile-title class="body-2" style="white-space: pre-wrap; height: auto;">{{ lecture.title }}</v-list-tile-title>-->
<!--                    <v-list-tile-action style="margin-top: 4px;">-->
<!--                      <v-layout row align-center justify-end>-->
<!--&lt;!&ndash;                        <span class="mr-1" style="font-size: 10px; letter-spacing: -0.2px; color: #9b9b9b;">&ndash;&gt;-->
<!--&lt;!&ndash;                          {{ Math.ceil(lecture.duration / 60) }}{{ 60 > lecture.duration ? '분 미만' : '분' }}&ndash;&gt;-->
<!--&lt;!&ndash;                        </span>&ndash;&gt;-->
<!--                        <v-btn icon small size="16px" @click.stop="$router.replace({ name: 'Lecture', params: { idx, lectureIdx: lecture.idx } })">-->
<!--                          <v-img style="flex-grow: 0;"-->
<!--                                 :src="require('@/assets/img/icon-play-active.png')"-->
<!--                                 width="16px" height="16px"></v-img>-->
<!--                        </v-btn>-->
<!--                      </v-layout>-->
<!--                    </v-list-tile-action>-->
<!--                  </v-list-tile>-->
<!--                </v-list>-->

<!--              </v-expansion-panel-content>-->
<!--            </v-expansion-panel>-->

<!--          </v-tab-item>-->

<!--        </v-tabs>-->
<!--      </v-flex>-->

    </v-layout>

<!--    <v-snackbar v-model="snackbar" bottom vertical :timeout="3000" auto-height>-->
<!--      {{ snackbarMessage }}-->
<!--      <v-btn color="primary" flat @click="snackbar = false">닫기</v-btn>-->
<!--    </v-snackbar>-->

  </v-container>
</template>

<script>
  import { mapGetters, mapActions, mapMutations } from 'vuex';
  import firebase from 'firebase/app';
  import 'firebase/auth';
  import videojs from 'video.js';
  // import '@videojs/http-streaming';
  import 'video.js/dist/video-js.css';
  // import VideoPlayer from '@/components/VideoPlayer';


  export default {
    name: 'Lecture',
    props: [ 'idx', 'lectureIdx' ],
    // components: { VideoPlayer },
    computed: {
      ...mapGetters('user', { userIdx: 'idx', loginAt: 'login_at', socialType: 'social_type' }),
      ...mapGetters('lecture', [ 'lecture', 'curriculum', 'curriculum_store_idx' ]),
      thumbnailSrc () {
        if (this.lecture.video_type === 'youtube' || this.lecture.video_type === 'thumbnailOnly') return this.lecture.thumbnailURL;
        else return this.lecture.thumbnailURL ? this.$CDN + this.lecture.thumbnailURL : require('@/assets/img/thumbnail-default.png');
      },
      origin () {
        return window.location.origin;
      },
      openPanel: {
        get () {
          let arr = [];
          for (let i = 0; i < this.curriculum.length; i++) {
            arr.push(true);
          }
          return arr;
        },
        set (value) {
          console.log(value);
        }
      },
      progressPercentage () {
        let arr = [];
        this.curriculum.forEach(chapter => {
          let all = 0;
          let completed = 0;
          chapter.lectures.forEach(lecture => {
            all++;
            if (lecture.complete) completed++;
          });
          if (all === 0) all = 1;
          arr.push(parseInt(completed / all));
        });
        return arr;
      }
    },
    data () {
      return {
        isLoading: true,
        paddingTop: (window.innerWidth * 9 / 16) + 48,
        activeTab: null,
        player: null,
        playerOptions: {
          // language: 'ko',
          // autoplay: false,
          // muted: false,
          // playbackRates: [0.5, 1.0, 1.5, 2.0],
          sources: [],
          poster: '',
          hls: {
            overrideNative: true
          },
          html5: {
            nativeAudioTracks: false,
            nativeTextTracks: false
          },
        },
        snackbarMessage: '',
        snackbar: false,
        removeCookie: false,
      };
    },
    created () {
      if (this.userIdx) this.selectSignedLecture();
      if (!this.curriculum.length || this.curriculum_store_idx !== this.idx) {
        this.selectCurriculum(this.idx).then();
      }
    },
    mounted () {
      this.isLoading = false;
      window.scrollTo(0, 0);
    },
    updated () {
      console.log('updated');
      // this.calculateIndicatorHeight();
    },
    beforeRouteUpdate (to, from, next) {
      if (this.lecture.video_type === 'hls') {
        this.updateLecturePlaytime().then(() => {
          next();
        });
      } else next();
    },
    beforeRouteLeave (to, from, next) {
      if (this.lecture.video_type === 'hls') {
        this.updateLecturePlaytime().then(() => {
          next();
        });
      } else next();
    },
    watch: {
      lecture: {
        handler: function (newVal) {
          console.log(newVal);
          this.playerOptions.poster = this.$CDN + newVal.thumbnailURL;
          // console.log('isSupported: ', videojs.Hls.isSupported());
          // if (videojs.Hls.isSupported()) {
          // this.playerOptions.sources = [{ src: this.$CDN + newVal.hlsSrc, type: 'application/x-mpegURL' }];
          // this.playerOptions.sources = [
          //   { src: this.$CDN + newVal.hlsSrc, type: 'application/x-mpegURL' },
          //   { src: this.$CDN + newVal.dashSrc, type: 'application/dash+xml' },
          //   { src: this.$CDN + newVal.mp4Src, type: 'video/mp4'},
          // ];
          if (newVal.video_type === 'hls') this.playerOptions.sources = [{ src: this.$CDN + newVal.mp4Src, type: 'video/mp4'}];
          else this.playerOptions.sources = [];
          this.activeTab = 'StoryNote';
        },
        deep: true
      },
      '$route' () {
        this.selectSignedLecture();
      },
      snackbar (flag) {
        if (flag && this.removeCookie) {
          this.signOut();
        } else {
          this.$router.go(-1);
        }
      },
    },
    methods: {
      ...mapActions('user', [ 'signOutUser' ]),
      ...mapActions('channel', [ 'toggleSubscription' ]),
      ...mapActions('lecture', [ 'selectCurriculum', 'selectLecture', 'updateSignedCookie', 'updatePlaytime' ]),
      ...mapMutations('lecture', {
        mutateToggleSubscription: 'TOGGLE_SUBSCRIPTION',
        mutateCompleteLecture: 'COMPLETE_LECTURE'
      }),
      calculateIndicatorHeight () {
        let listTiles = document.getElementsByClassName('v-list__tile');
        console.log(listTiles);
        for (let i = 0; i < listTiles.length - 1; i++) {
          console.log(listTiles[i], listTiles[i].offsetTop);
          // console.log(listTiles[i + 1].offsetTop, listTiles[i].offsetTop);
        }
      },
      subscribe (idx) {
        this.toggleSubscription(idx).then(response => {
          this.mutateToggleSubscription({ idx, flag: response.data });
        }).catch(err => {
          console.error(err);
        });
      },
      selectSignedLecture () {
        this.updateSignedCookie({ storeIdx: this.idx, lectureIdx: this.lectureIdx, loginAt: this.loginAt }).then(response => {
          videojs.Hls.xhr.beforeRequest = function (options) {
            options.uri = options.uri.concat('?', response.data.policy);
            return options;
          };
          this.selectLecture({
            storeIdx: this.idx,
            lectureIdx: this.lectureIdx,
            policy: response.data.policy,
          });
        }).catch(err => {
          console.error(err);
          const errorCode = err.response.data.code;
          if (errorCode === 'signin_again') {
            alert('다시 로그인해주세요.');
            this.removeCookie = true;
            // this.showSnackbar('다시 로그인해주세요.');
            this.signOut();
          } else if (errorCode === 'concurrent_access') {
            alert('다른 기기에서 접속중입니다. 다시 로그인해주세요.');
            this.removeCookie = true;
            // this.showSnackbar('다른 기기에서 접속중입니다. 다시 로그인해주세요.');
            this.signOut();
          } else if (errorCode === 'period_expired') {
            alert('수강기간이 만료되었습니다.');
            this.removeCookie = true;
            // this.showSnackbar('수강기간이 만료되었습니다.');
            this.$router.go(-1);
          } else if (errorCode === 'not_opened') {
            alert('아직 오픈되지 않은 강의입니다.');
            this.removeCookie = true;
            // this.showSnackbar('아직 오픈되지 않은 강의입니다.');
            this.$router.go(-1);
          } else {
            // this.removeCookie = true;
            alert('구매하지 않은 강의입니다.');
            // this.showSnackbar('구매하지 않은 강의입니다.');
            this.$router.go(-1);
          }
        });
      },
      updateLecturePlaytime (userPlaytime) {
        this.isLoading = true;
        if (typeof userPlaytime === 'undefined') userPlaytime = this.player ? Math.floor(this.player.currentTime()) : 0;
        return new Promise((resolve, reject) => {
          this.updatePlaytime({
            storeIdx: this.idx,
            lectureIdx: this.lectureIdx,
            userPlaytime,
            lastViewedTime: new Date().getTime(),
          }).then(response => {
            console.log(response);
            if (response.code === 'success') {
              this.mutateCompleteLecture({
                storeIdx: response.store_idx,
                lectureIdx: response.lecture_idx,
                flag: response.complete
              });
              resolve(response);
            }
            reject(response);
          }).catch(reject);
        });
      },
      onPlayerReady (player) {
        this.player = player;
      },
      onLoaded (player) {
        // console.log('onLoaded', player);
        if (this.lecture.user_playtime < player.currentTime() - 5) player.currentTime(this.lecture.user_playtime);
        console.log('currentTime: ', player.currentTime());
        console.log('duration: ', player.duration());
        console.log('remainingTime: ', player.remainingTime());
      },
      onEnded (player) {
        // console.log('onEnded', player);
        // console.log('currentTime: ', player.currentTime());
        // console.log('duration: ', player.duration());
        // console.log('remainingTime: ', player.remainingTime());
        this.isLoading = true;
        this.updateLecturePlaytime(Math.floor(player.currentTime())).then(response => {
          console.log(response);
          this.findNextLecture();
        }).catch(err => {
          console.error(err);
        }).finally(() =>  {
          console.log('finally');
          this.isLoading = false;
        });
      },
      onError (player) {
        console.log('onError: ', player);
        // this.playerOptions.sources = [
          // { src: this.$CDN + this.lecture.hlsSrc, type: 'application/x-mpegURL' },
          // { src: this.$CDN + this.lecture.dashSrc, type: 'application/dash+xml' },
          // { src: this.$CDN + this.lecture.mp4Src, type: 'video/mp4'},
        // ];
      },
      showSnackbar (message) {
        this.snackbarMessage = message;
        this.snackbar = true;
      },
      findNextLecture () {
        let lectures = [];
        let lectureIdx = null;
        for (let chapter of this.curriculum) {
          lectures.push(...chapter.lectures);
        }
        let targetIdx = lectures.findIndex(el => {
          return el.idx === parseInt(this.lectureIdx);
        });
        if (targetIdx > -1) lectureIdx = lectures[targetIdx + 1].idx;
        else lectureIdx = -1;
        if (lectureIdx > -1) {
          console.log(`next: lecture ${lectureIdx}`);
          this.$router.replace({ name: 'Lecture', params: { idx: this.idx, lectureIdx } });
        } else {
          console.log('the end of the story');
          // TODO: 리뷰 작성 페이지로 보내기
          this.showSnackbar('마지막 강의입니다.');
          // alert('마지막 강의입니다.');
        }
      },
      signOut () {
        this.isLoading = true;
        this.signOutUser();
        window.localStorage.removeItem('jwt');
        if (window.native) {
          window.native.setJWT(null);
          this.$router.push({ name: 'SocialLogin', query: { redirect: this.$route.path } });
        } else if (typeof webkit !== 'undefined') {
          // eslint-disable-next-line
          webkit.messageHandlers.setJWT.postMessage(null);
          this.$router.push({ name: 'SocialLogin', query: { redirect: this.$route.path } });
        } else {
          let root = this;
          if (this.socialType === 'kakao') {
            console.log('signOutKaKao');
            try {
              // eslint-disable-next-line
              Kakao.Auth.logout();
            } catch (e) {
              root.isLoading = false;
              console.error(e);
            }
            root.$router.push({ name: 'SocialLogin', query: { redirect: root.$route.path } });
          } else {
            firebase.auth().signOut().then(() => {
              console.log('signOutFirebase');
            }).catch(error => {
              root.isLoading = false;
              console.log(error);
            }).finally(() => {
              window.location.href = `/social-login?redirect=${root.$route.path}`; // 파이어베이스 버그: 인스턴스 유지하면 auth().signOut()이 제대로 실행이 안되어서 다시 로그인됨
            });
          }
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
  /deep/.extension-padding .v-toolbar__extension {
    height: auto !important;
    padding: 0;
  }

  /deep/.v-btn--depressed {
    border-color: #cdcdcd !important;
  }

  .thumbnail-text {
    &-time {
      opacity: 0.8;

      font-size: 14px;
      font-weight: 700;
      letter-spacing: -0.3px;
      color: white;
      &.dark-text {
        color: map_get($colors, charcoal);
      }
    }
    &-title {
      font-size: 20px;
      font-weight: 700;
      letter-spacing: -0.3px;
      line-height: 24px;
      color: white;
      &.dark-text {
        color: map_get($colors, charcoal);
      }
    }
  }
  .body-1 {
    line-height: 20px;
    word-break: keep-all;
    word-wrap: break-word;
  }

  /deep/.card-shadow {
    box-shadow: 0 2px 3px map-get($colors, background-shadow);
  }

  /deep/.border-radius-custom {
    overflow: hidden;
    border-radius: 21px !important;
    .v-input__slot {
      cursor: pointer !important;
      padding: 0 18px !important;
    }
    input {
      cursor: pointer !important;
    }
    .v-icon {
      color: map_get($colors, primary);
      font-size: 12px;
    }
  }

  /deep/ .v-btn__content {
    flex-direction: column;
    & > span {
      font-size: 10px;
      line-height: 14px;
      font-weight: 700;
      letter-spacing: -0.2px;
      color: map_get($colors, charcoal);
    }
  }
  .counter {
    color: map_get($colors, charcoal);
    font-size: 10px;
    font-weight: 700;
    line-height: 14px;
    letter-spacing: -0.2px;
  }

  /deep/.v-tabs__item {
    font-size: 16px;
    letter-spacing: -0.3px;
    color: map_get($colors, primary);
    &:not(.v-tabs__item--active) {
      opacity: 1;
      color: map_get($colors, brown-grey);
    }
  }
  /deep/ .v-tabs__container {
    height: 40px;
  }

  /deep/.curriculum {
    padding-top: 30px;
    padding-bottom: 30px;
    .v-expansion-panel__container {
      border-top: 0;
    }
    .v-expansion-panel__header {
      padding: 8px 16px;
      align-items: flex-end;
      margin-top: 2px;
      margin-bottom: 2px;
    }
    .v-expansion-panel__header__icon {
      i {
        font-size: 16px;
      }
    }

    div[role=listitem] .v-list__tile {
      height: auto;
      align-items: flex-start;
    }

    div[role=listitem] .v-list__tile__avatar {
      min-width: 16px;
      margin-right: 8px;
      margin-top: 4px;
      position: relative;
      .indicator {
        position: absolute;
        top: 16px;
        left: 8px;
        min-width: 1px;
        width: 1px;
        height: 32px;
        background-color: #cdcdcd;
        z-index: 0;
      }
      /* TODO: indicator color */
      /*&.complete {*/
      /*  &:before {*/
      /*    content: '';*/
      /*    position: absolute;*/
      /*    bottom: 16px;*/
      /*    left: 8px;*/
      /*    min-width: 1px;*/
      /*    width: 1px;*/
      /*    height: 32px;*/
      /*    z-index: 1;*/
      /*    background-image: linear-gradient(to top, #ec2f54, rgba(#ec2f54, 0));*/
      /*  }*/
      /*  &:after {*/
      /*    content: '';*/
      /*    position: absolute;*/
      /*    top: 16px;*/
      /*    left: 8px;*/
      /*    min-width: 1px;*/
      /*    width: 1px;*/
      /*    height: 32px;*/
      /*    z-index: 1;*/
      /*    background-image: linear-gradient(to bottom, #ec2f54, rgba(#ec2f54, 0));*/
      /*  }*/
      /*}*/
    }
    div[role=listitem]:first-child .v-list__tile__avatar.complete:before {
      display: none;
    }
    div[role=listitem]:last-child .v-list__tile__avatar {
      .indicator {
        display: none;
      }
      &.complete:after {
        display: none;
      }
    }

    .v-avatar .v-icon {
      transform: scale(0.5);
    }
  }
</style>
